// client/src/utils/collegeUtils.js

// Define the mapping of college names to logo filenames
const logoMap = {
  'Harvard': 'Harvard_University_shield.png',
  'Yale': 'Yale-logo.png',
  'Princeton': 'princetonlogo.png',
  'UPenn': 'pennlogo.png',
  'Columbia': 'Columbialogo.png',
  'Brown': 'brownlogo.png',
  'Dartmouth': 'Dartmouth-Symbol.png',
  'Cornell': 'cornelllogo.png',
  'Stanford': 'Stanfordlogo.png',
  'MIT': 'MIT-Emblem.png',
  'Caltech': 'caltechlogo.png',
  'UChicago': 'uchicagologo.png',
  'Northwestern': 'Northwestern-Wildcats-Logo-1981.png',
  'Duke': 'dukelogo.png',
  'Johns Hopkins': 'JHUlogo.png',
  'Vanderbilt': 'vanderbiltlogo.png',
  'UC Berkeley': 'ucberkeleylogo.png',
  'UCLA': 'uclalogo.png',
  'UMichigan': 'uofmlogo.png',
  'UVA': 'UVAlogo.png',
  'UNC Chapel Hill': 'unclogo.png',
  'Georgia Tech': 'georgiatechlogo.png',
  'NYU': 'nyulogo.png',
  'CMU': 'CMUlogo.png',
  'USC': 'USC_logo.png',
  'WashU': 'Washington_University_logo.png',
  'Rice': 'Rice_logo.png',
  'Notre Dame': 'Notre_dame_logo.png',
  'Northeastern': 'Northeastern_logo.png',
  'Georgetown': 'Georgetown_logo.png'
  // Add any other colleges from your topColleges list if needed
};

/**
 * Gets the path to the college logo.
 * Assumes logos are in the /public/logos/ directory.
 * @param {string} collegeName - The name of the college.
 * @returns {string|null} The path to the logo or null if not found.
 */
export const getLogoPath = (collegeName) => {
  const fileName = logoMap[collegeName];
  // Ensure logos are served from the root public directory
  return fileName ? `/logos/${fileName}` : null;
};

/**
 * Generates initials for a college name, with specific overrides.
 * @param {string} collegeName - The name of the college.
 * @returns {string} The generated initials (e.g., 'HVD', 'UCB', 'MIT').
 */
export const getCollegeInitials = (collegeName) => {
  if (!collegeName) return '';

  // Specific overrides for common abbreviations
  const overrides = {
    'UC Berkeley': 'UCB',
    'UCLA': 'UCLA',
    'UMichigan': 'UM',
    'UNC Chapel Hill': 'UNC',
    'Johns Hopkins': 'JHU',
    'Georgia Tech': 'GT',
    'Notre Dame': 'ND',
    'MIT': 'MIT',
    'UPenn': 'PENN', // Common abbreviation
    'CMU': 'CMU',
    'USC': 'USC',
    'WashU': 'WashU',
    'NYU': 'NYU'
  };

  if (overrides[collegeName]) {
    return overrides[collegeName];
  }

  // Default logic: initials of first letters, max 3 chars
  return collegeName
    .split(' ')
    .map(word => word[0])
    .join('')
    .substring(0, 3)
    .toUpperCase();
}; 